import { Box, BoxProps } from '@chakra-ui/react';
import { moveToLeft, moveToRight } from './animation';

export function Loader({
  height = '50px',
  width = '68px',
  ...rest
}: BoxProps): JSX.Element {
  return (
    <Box
      data-testid="loader"
      position="relative"
      w={width}
      h={height}
      {...rest}
    >
      <Circle
        gradientStartColor={'rgba(248, 108, 182, 0.68)'}
        gradientEndColor={'rgba(255, 33, 117, 0.82)'}
        animation={`${moveToRight} 2s ease infinite`}
      />
      <Circle
        gradientStartColor={'rgba(85, 108, 248, 0.72)'}
        gradientEndColor={'rgba(86, 218, 231, 0.72)'}
        animation={`${moveToLeft} 2s ease infinite`}
      />
    </Box>
  );
}

function Circle({
  gradientStartColor,
  gradientEndColor,
  width = '50px',
  height = '50px',
  animation
}: {
  gradientStartColor: string;
  gradientEndColor: string;
} & BoxProps): JSX.Element {
  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      width={width}
      height={height}
      borderRadius="50%"
      background={`linear-gradient(180deg, ${gradientStartColor} 0%, ${gradientEndColor} 100%)`}
      animation={animation}
    />
  );
}
